<template>
  <component :is="currentView" keep-alive></component>
</template>

<script>
import FormView from './views/FormView.vue'
import ResponseSuccessView from './views/ResponseSuccessView.vue'
import ResponseErrorView from './views/ResponseErrorView.vue'
import LoadingView from './views/LoadingView.vue'

export default {
  name: 'Router',
  components: [
    FormView,
    ResponseSuccessView,
    ResponseErrorView,
    LoadingView
  ],
  data() {
    return {
      currentView: 'FormView'
    }
  },
  events: {
    'router-load'() {
      this.changeView('LoadingView')
    },
    'router-success'() {
      this.changeView('ResponseSuccessView')
    },
    'router-error'() {
      this.changeView('ResponseErrorView')
    },
    'router-form'() {
      this.changeView('FormView')
    }
  },
  methods: {
    changeView(viewComponent) {
      this.currentView = viewComponent
    }
  }
}
</script>


// WEBPACK FOOTER //
// Router.vue?7df793b2